import { useTranslation } from 'react-i18next';
import { SsoIntegration } from 'graphql-common';
import MaterialIcon from '@lib/components/MaterialIcon/MaterialIcon';
import SsoDisplayStatusChip from '@lib/components/SsoDisplayStatusChip/SsoDisplayStatusChip';
import Typography from '@lib/components/Typography/Typography';
import entityViewStyles from '@lib/assets/styles/EntityView.module.scss';
import { getFormattedDate } from '@lib/utils/dateTimeHelpers';
import { dateTimeFormatEU } from '@lib/enums/dateTime';

interface Props {
  data?: SsoIntegration;
}

export default function SsoDetailsSection({ data }: Props) {
  const { t } = useTranslation();

  return (
    <div className={entityViewStyles.infoList}>
      <div className={entityViewStyles.infoItem}>
        <p className={entityViewStyles.infoItemLabel}>
          <MaterialIcon icon="track_changes" symbolsOutlined />
          <Typography variant="caption">{t('status')}</Typography>
        </p>
        <div className={entityViewStyles.infoItemContent}>
          {data ? (
            <SsoDisplayStatusChip data={data} />
          ) : (
            <Typography variant="body">-</Typography>
          )}
        </div>
      </div>
      <div className={entityViewStyles.infoItem}>
        <p className={entityViewStyles.infoItemLabel}>
          <MaterialIcon icon="update" symbolsOutlined />
          <Typography variant="caption">{t('last-updated')}</Typography>
        </p>
        <div className={entityViewStyles.infoItemContent}>
          <Typography variant="body">
            {data?.updatedAt
              ? getFormattedDate(data.updatedAt, dateTimeFormatEU)
              : '-'}
          </Typography>
        </div>
      </div>
    </div>
  );
}
